
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import "./whatsappTemplateModal.scss"
import api from "../../core/axios/axiosInstance";
import { Button } from "antd";
import { attachMetaMessageId, sendMessage } from "../../core/data/redux/slices/WabaChatSlice";
import { useDispatch } from "react-redux";

const DYNAMIC_FIELDS = [
  { label: "First Name",    value: "first_name" },
  { label: "Last Name",     value: "last_name" },
  { label: "Phone",         value: "phone" },
  { label: "Email",         value: "email" },
  { label: "Company Name",  value: "company_name" },
];


const WhatsappTemplateModal = ({ from }) => {
  const { wabaTemplates, loading } = useSelector(
    (state) => state.wabaTemplate
  );
  const dispatch = useDispatch()

  const closeBtnRef = useRef(null);
  const activeChatName = useSelector((state) => {
    const { conversations, activeChatId } = state.wabaChat;
    const chat = conversations.find(c => c.from === activeChatId);
    // Try: conversation name -> first message name -> fallback to from number
    return (
      chat?.name ||
      chat?.messages?.find(msg => msg.name)?.name ||
      chat?.from ||
      "Unknown"
    );
  });
  const { conversations, activeChatId, showContact } = useSelector(
    state => state.wabaChat
  );
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [buttonConfig, setButtonConfig] = useState({});
  const [bodyParamValues, setBodyParamValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  /* ---------------- helpers ---------------- */


  const approvedTemplates = wabaTemplates
    ?.filter((t) => t.status === "APPROVED")
    .map((t) => ({
      label: t.name,
      value: t.metaTemplateId,
      template: t
    }));




    
  const getComponent = (components, type) =>
    components?.find((c) => c.type === type);

  const renderBodyText = (
    text = "",
    dynamicValues = {}
  ) => {
    let rendered = text;

    Object.keys(dynamicValues).forEach((key) => {
      rendered = rendered.replaceAll(
        `{{${key}}}`,
        dynamicValues[key]
      );
    });

    return rendered;
  };



  const handleTypeChange = (index, type) => {
    setButtonConfig((prev) => ({
      ...prev,
      [index]: { type }
    }));
  };

  const handleStaticText = (index, text) => {
    setButtonConfig((prev) => ({
      ...prev,
      [index]: { ...prev[index], value: text }
    }));
  };

  const handleDynamicField = (index, field) => {
    setButtonConfig((prev) => ({
      ...prev,
      [index]: { type: "dynamic", value: field }
    }));
  };

  const getButtonPreviewText = (btn, index) => {
    const cfg = buttonConfig[index];
    if (!cfg) return btn.text;

    if (cfg.type === "static") return btn.text;
    // if (cfg.type === "static") return cfg.value || btn.text;
    if (cfg.type === "dynamic") return btn.text;;
    // if (cfg.type === "dynamic") return `{{${cfg.value}}}`;

    return btn.text;
  };





  const buttonsComponent =
    selectedTemplate &&
    getComponent(selectedTemplate.components, "BUTTONS");

  const headerComponent = selectedTemplate &&
    getComponent(selectedTemplate.components, "HEADER");

  const bodyComponent = selectedTemplate &&
    getComponent(selectedTemplate.components, "BODY");

  const footerComponent = selectedTemplate &&
    getComponent(selectedTemplate.components, "FOOTER");
  const buildBodyParams = (template, dynamicValues = {}) => {
    const bodyComponent = template?.components?.find(
      (c) => c.type === "BODY"
    );

    if (!bodyComponent?.example?.body_text_named_params) {
      return null;
    }

    return bodyComponent.example.body_text_named_params.map(
      (p) => dynamicValues[p.param_name] ?? null
    );
  };
  const buildButtonParams = (template, buttonConfig = {}, dynamicValues = {}) => {
    const buttonsComponent = template?.components?.find(
      (c) => c.type === "BUTTONS"
    );

    if (!buttonsComponent?.buttons?.length) {
      return null;
    }

    return buttonsComponent.buttons.map((btn, index) => {
      // COPY_CODE: always use template's example code
      if (btn.type === "COPY_CODE") {
        return btn.example || null;
      }

      const cfg = buttonConfig[index];

      // If user didn't configure → null
      if (!cfg || !cfg.value) return null;

      // Static value
      if (cfg.type === "static") {
        return cfg.value || null;
      }

      // Dynamic value
      if (cfg.type === "dynamic") {
        return dynamicValues[cfg.value] ?? null;
      }

      return null;
    });
  };
  const buildParams = (template, buttonConfig, dynamicValues) => {
    const body = buildBodyParams(template, dynamicValues);
    const buttons = buildButtonParams(template, buttonConfig, dynamicValues);

    const params = {};

    if (body && body.length) {
      params.body = body;
    }

    if (buttons && buttons.length) {
      params.buttons = buttons;
    }

    return params;
  };


  const handleSendTemplate = async () => {
    setIsLoading(true)
    const toNumber = typeof from === "object" ? from.from : from;
    const tempId = `tmp_${Date.now()}`;
    try {
      const dynamicValues = {
        first_name:   activeChatName || "",
        last_name:    "",
        phone:        typeof from === "object" ? from.from : from,
        email:        "",
        company_name: "",
        ...bodyParamValues,
      };

      const params = buildParams(
        selectedTemplate,
        buttonConfig,
        dynamicValues
      );

      const payload = {
        templateId: selectedTemplate._id,
        to: toNumber,
        name: activeChatName,
        ...(Object.keys(params).length && { params })
      }
      console.log(payload, "payload for send template");


      const response = await api.post("/api/whatsapp/send-template", payload)

      console.log(response.data, "response from send template");

      dispatch(sendMessage({
        chatId: activeChatId,
        name: activeChatName,
        tempId,
        type: "template",
        template: {
          ...selectedTemplate,
          dynamicValues
        }
      }));

      setSelectedTemplate(null);
      setSelectedOption(null);
      setButtonConfig({});
      setBodyParamValues({});



      const metaMessageId = response.data.data.messages[0].id;

      console.log(activeChatId,
        tempId,
        metaMessageId,

        "activeChatId,tempId,metaMessageId");

      dispatch(
        attachMetaMessageId({
          chatId: activeChatId,
          tempId,
          metaMessageId,
        }))
      setIsLoading(false)
      console.log("clicking the button");

      closeBtnRef.current?.click();
    } catch (error) {
      console.log("error sending template:", error);
      setIsLoading(false)
    }
  }

  const headerFormat =
    headerComponent?.format
      ? headerComponent.format.toLowerCase()
      : null;

  const headerMediaUrl = headerComponent?.media?.s3Url;

  return (
    <div
      className="modal custom-modal fade modal-padding"
      id="show_whatsapp_templates"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">Select Template</h5>
            <button
              type="button"
              className="btn-close position-static"
              data-bs-dismiss="modal"
            >
              ×
            </button>
          </div>


          <div className="modal-body">

            <div className="mb-3">
              <Select
                options={approvedTemplates}
                value={selectedOption}
                isLoading={loading}
                onChange={(opt) => {
                  setSelectedOption(opt);
                  setSelectedTemplate(opt?.template);
                  setButtonConfig({});
                  // Pre-fill known contact fields, leave unknowns empty
                  const namedParams = opt?.template?.components
                    ?.find(c => c.type === "BODY")
                    ?.example?.body_text_named_params || [];
                  const prefilled = {};
                  const contactDefaults = {
                    first_name: activeChatName || "",
                    last_name: "",
                    phone: typeof from === "object" ? from.from : from,
                    email: "",
                    company_name: "",
                  };
                  namedParams.forEach(p => {
                    prefilled[p.param_name] = contactDefaults[p.param_name] ?? "";
                  });
                  setBodyParamValues(prefilled);
                }}
                placeholder="Select a template"
              />
            </div>

            {selectedTemplate && (
              <div className="row mt-3">
                <div className="col-md-6 border-end">
                  {/* Body param inputs */}
                  {Object.keys(bodyParamValues).length > 0 && (
                    <div className="mb-4">
                      <h6 className="fw-bold mb-2">Message Variables</h6>
                      {Object.entries(bodyParamValues).map(([paramName, value]) => (
                        <div key={paramName} className="mb-2">
                          <label className="form-label small text-muted mb-1">
                            {`{{${paramName}}}`}
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={value}
                            onChange={(e) =>
                              setBodyParamValues(prev => ({ ...prev, [paramName]: e.target.value }))
                            }
                            placeholder={`Value for {{${paramName}}}`}
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  <h6 className="fw-bold mb-3">Template Buttons</h6>

                  {!buttonsComponent && (
                    <p className="text-muted">No buttons in this template</p>
                  )}

                  {/* {buttonsComponent?.buttons.map((btn, i) => (
                    <div key={i} className="mb-4">
                      <div className="fw-semibold mb-1">
                        Button {i + 1} ({btn.type})
                      </div>

                      <Select
                        className="mb-2"
                        options={[
                          { label: "Static", value: "static" },
                          { label: "Dynamic", value: "dynamic" }
                        ]}
                        onChange={(opt) =>
                          handleTypeChange(i, opt.value)
                        }
                        placeholder="Select type"
                      />

                      {buttonConfig[i]?.type === "static" && (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter button text"
                          onChange={(e) =>
                            handleStaticText(i, e.target.value)
                          }
                        />
                      )}

                      {buttonConfig[i]?.type === "dynamic" && (
                        <Select
                          options={DYNAMIC_FIELDS}
                          onChange={(opt) =>
                            handleDynamicField(i, opt.value)
                          }
                          placeholder="Select field"
                        />
                      )}
                    </div>
                  ))} */}
                  {buttonsComponent?.buttons.map((btn, i) => {
                    const hasDynamicUrl = btn.type === "URL" && /{{.*?}}/.test(btn.url || "");

                    return (
                      <div key={i} className="mb-3 p-2 border rounded">
                        {btn.type === "PHONE_NUMBER" && (
                          <div className="text-muted small">
                            📞 <strong>{btn.text}</strong> — {btn.phone_number}
                          </div>
                        )}

                        {btn.type === "URL" && !hasDynamicUrl && (
                          <div className="text-muted small">
                            🔗 <strong>{btn.text}</strong> — {btn.url}
                          </div>
                        )}

                        {btn.type === "URL" && hasDynamicUrl && (
                          <div className="text-muted small">
                            🔗 <strong>{btn.text}</strong> — URL resolved from contact
                          </div>
                        )}

                        {btn.type === "QUICK_REPLY" && (
                          <div className="text-muted small">
                            ↩ <strong>{btn.text}</strong>
                          </div>
                        )}

                        {btn.type === "COPY_CODE" && (
                          <div className="text-muted small">
                            📋 <strong>{btn.text || "Copy Code"}</strong> — {btn.example || "code from template"}
                          </div>
                        )}
                      </div>
                    );
                  })}



                </div>

                <div className="col-md-6 d-flex justify-content-center">
                  <div className="wa-preview">
                    <div className="wa-bubble">
                      {headerComponent && (
                        <div className="wa-header">
                          {/* TEXT HEADER */}
                          {headerFormat === "text" && headerComponent.text && (
                            <div className="wa-header-text">
                              {headerComponent.text}
                            </div>
                          )}

                          {/* IMAGE HEADER */}
                          {headerFormat === "image" && headerMediaUrl && (
                            <img
                              src={headerMediaUrl}
                              alt="Template Header"
                              className="wa-header-image"
                            />
                          )}

                          {/* VIDEO HEADER */}
                          {headerFormat === "video" && headerMediaUrl && (
                            <video
                              src={headerMediaUrl}
                              controls
                              className="wa-header-video"
                            />
                          )}

                          {/* DOCUMENT HEADER */}
                          {headerFormat === "document" && (
                            <div className="wa-header-document">
                              📄 {headerComponent.media?.fileName || "Document"}
                            </div>
                          )}
                        </div>
                      )}


                      {bodyComponent && (
                        <div className="wa-body">
                          {renderBodyText(
                            bodyComponent.text,
                            selectedTemplate?.dynamicValues
                          )}
                        </div>
                      )}

                      {footerComponent && (
                        <div className="wa-footer">
                          {footerComponent.text}
                        </div>
                      )}

                      {buttonsComponent && (
                        <div className="wa-buttons">
                          {buttonsComponent.buttons.map((btn, i) => (
                            <button key={i} className="wa-btn">
                              {getButtonPreviewText(btn, i)}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              </div>
            )}

            <div className="modal-footer-custom">
              <Button
                type="primary"
                style={{ background: "#008069" }}
                onClick={handleSendTemplate}
                loading={isLoading}
              >
                {isLoading ? "Sending" : "Send"}
              </Button>
              <button
                ref={closeBtnRef}
                type="button"
                className="d-none"
                data-bs-dismiss="modal"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappTemplateModal;